module.exports = __webpack_public_path__ + "img/staff-2018-badminton.43dca03d.jpg";